import LoanModal from "./uloanModal.js";
import { $_GET } from "../globalFunctions.js";

export default class PayoutModal extends LoanModal {
  constructor(companyId) {
    super("payout-modal", companyId);
    this.$stakeholder = this.$form.querySelector('[name="stakeholder"]');

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "amount",
        varType: "float",
        required: true,
      },
      {
        name: "beneficiary",
        varType: "int",
      },
      {
        name: "stakeholder",
        varType: "int",
        required: true,
        trigger: "change",
      },
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "documents",
        varType: "simple-array",
        type: "int",
      },
      {
        name: "notes",
      },
    ];

    this.setupForm();

    Promise.all([
      this.documentsPromise,
      this.setupStakeholders(),
      this.getPublicValuation(this.$date.value),
    ]).then(() => {
      this.whenReady();
    });
  }

  whenReady() {
    super.whenReady();

    if (typeof this.transaction !== "undefined") {
      this.setTransactionData(this.transaction);
    }

    this.setFloat("retention", 0);

    this.setFromLoan(this.fromLoan);
    this.fromLoan = false;

    const $loanSummary = document.getElementById("loan-summary");
    if (this.isFromLoan()) {
      $loanSummary.classList.remove("d-none");
      this.setAmountToConvert(this.calculateAmountToConvert());
    } else {
      $loanSummary.classList.add("d-none");
    }
  }

  setupForm() {
    this.$date.valueAsDate = new Date();
    this.$toConvert?.parentElement.classList.add("d-none");

    this.$form
      .querySelector('[data-action-transaction="edit"]')
      .addEventListener("click", () => {
        this.hide();
        window["reactEditTransaction"].dispatchEvent(
          new CustomEvent("edit", {
            detail: {
              id: this.transaction.id,
            },
          })
        );
      });

    this.$date.addEventListener("change", () => {
      this.getPublicValuation(this.$date.value);
    });

    if (this.isFromLoan()) {
      this.$form
        .querySelector('[name="retention"]')
        .addEventListener("input", () => {
          const retention = this.getFloat("retention");

          if (retention > 100 || retention < 0) {
            this.setFloat("retention", 100);
          }

          this.setAmountToConvert(this.calculateAmountToConvert());
        });
    }
  }

  setTransactionData(transaction) {
    super.setTransactionData(transaction);
    this.setFromLoan(typeof transaction.loan !== "undefined");
  }

  calculateAmountToConvert() {
    const toConvert = super.calculateAmountToConvert();

    if (this.$toReturn) {
      this.$toReturn.innerText = peque.formatNumber(toConvert);
    }

    this.setFloat("amount", toConvert);

    return toConvert;
  }

  setFromLoan(fromLoan) {
    this.fromLoan = fromLoan;

    const $beneficiary = this.$form.querySelector('[name="beneficiary"]');

    if (this.fromLoan) {
      this.$stakeholder.disabled = "disabled";
      $beneficiary.disabled = "disabled";
    } else {
      this.$stakeholder.removeAttribute("disabled");
      $beneficiary.removeAttribute("disabled");
    }
  }

  isFromLoan() {
    return this.$stakeholder.disabled;
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.simulation =
          typeof window.pequeData.simulation === "undefined"
            ? $_GET("simulation")
            : window.pequeData.simulation;
        data.type = peque.TRANSACTION_TYPE_PAYOUT;

        peque
          .api(
            this.isFromLoan()
              ? "loans/" + data.id + "/payback"
              : "transactions",
            JSON.stringify(data),
            "post"
          )
          .then((response) => {
            if (typeof response.error === "undefined" || response.error > 0) {
              return;
            }
            this.mutateReactTransactions();
          })
          .catch((error) => {
            this.enableSubmitButton(true);
            peque.navigation.showError(error.result);
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);
        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
